import commonDialog from "./common-center-dialog-v2.vue";
const commonCenterDialogV2 = {
  name:'common-center-dialog-v2',
  install: function (Vue) {
    Vue.component("common-center-dialog-v2", commonDialog);
  },
};
// 导出该组件
export default commonCenterDialogV2;
